import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  OutlinedInput,
  Checkbox, FormGroup,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { createAbility, updateAbility } from "../../../config/acl/ability";

const AddRoleForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [formData, setFormData] = useState({
    name: "",
    permissions: [], // Initialize permissions as an empty array
  });

  const [permissions, setPermissions] = useState([]);

  const getPermissions = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.Permissions.View}`,
      });
      if (response) {
        setPermissions(response.data);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPermissions();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setFormData((prev) => ({
        ...prev,
        photo: files[0],
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (errorMessage && name === "password") {
        if (value === formData.password_confirmation) setErrorMessage();
      }
      if (errorMessage && name === "password_confirmation") {
        if (value === formData.password) setErrorMessage();
      }
    }
  };

  const handlePermissionChange = (e) => {
    const { checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      permissions: checked
        ? [...(prev.permissions || []), value]
        : prev.permissions.filter((id) => id !== value), // Use .filter directly
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (formData.password !== formData.password_confirmation) {
      setErrorMessage(
        "Passwords do not match! Please ensure both passwords are the same."
      );
      return;
    }

    setIsLoading(true);

    const formDataToSend = new FormData();
    for (let key in formData) {
      if (key === "photo") {
        if (formData.photo && typeof formData.photo !== "string") {
          formDataToSend.append("photo", formData.photo);
        }
      } else if (key === "permissions") {
        formData.permissions.forEach((permissionId) => {
          formDataToSend.append("permissions[]", permissionId);
        });
      } else if (formData[key] !== null) {
        formDataToSend.append(key, formData[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.Roles.Add,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoading(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/roles");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoading(false);
    }
  };

  return (
      <form onSubmit={handleSubmit}>
        <TextField
            fullWidth
            margin="normal"
            label="Role Name"
            name="name"
            required
            autoComplete="off"
            value={formData.name}
            onChange={handleInputChange}
            variant="outlined"
        />

        <FormLabel
            sx={{ fontWeight: "bold", textAlign: "left", width: "100%", mt: 2, display: "block" }}
            component="legend"
        >
          Permissions:
        </FormLabel>
        <FormGroup sx={{ mt: 1 }}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            {permissions.map((permission) => (
                <FormControlLabel
                    key={permission.id}
                    control={
                      <Checkbox
                          value={permission.id.toString()}
                          checked={formData.permissions.includes(permission.id.toString())}
                          onChange={handlePermissionChange}
                      />
                    }
                    label={permission.name}
                />
            ))}
          </div>
        </FormGroup>

        <Button
            type="submit"
            variant="contained"
            disabled={isLoading}
            color="primary"
            sx={{
              display: isLoading ? "flex" : "block",
              marginTop: 3,
              width: "20%",
              marginX: "auto",
              fontWeight: "bold",
              justifyContent: "center",
            }}
        >
          {isLoading ? (
              <CircularProgress size={24} color="primary" />
          ) : (
              "Create"
          )}
        </Button>
      </form>
  );
};

export default AddRoleForm;
